import './CheckboxSelector.css'

const CheckboxSelector = ({ checkboxSelected, setCheckboxSelected, label }) => {
    return (
        <div className="checkboxSelector_box">
            {/* <label className="toggle" id="cb-selector">
                <input className="toggle-checkbox"
                    type="checkbox"
                    checked={checkboxSelected}
                    onChange={() => setCheckboxSelected(prevState => !prevState)}
                />
                <div className="toggle-switch"></div>
            {label && <label htmlFor='cb-selector'>{label}</label>}
            </label> */}

            <input 
            id='cb-selector'
            className="checkbox"
                type='checkbox'
                checked={checkboxSelected}
                onChange={() => { setCheckboxSelected(prev => !prev || prev === 'false' ? true : false) }}
            />
            {label && <label htmlFor='cb-selector'>{label}</label>}

        </div>
    )
}

export default CheckboxSelector